import { eventBus } from '@/main'

// Notification sound to play when a message is received
const audio = new Audio('/static/notification.mp3')

// Listen for the message event
export default {
  created() {
    eventBus.$on('chat:message', this.onMessage)
  },
  beforeDestroy() {
    eventBus.$off('chat:message', this.onMessage)
  },
  methods: {
    // Called when we receive a new chat message
    onMessage() {
      if (this.$route.name === 'DashboardMessages') return
      audio.play()
    },
  },
}
